import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UsersService } from '~core/data/users.service';
import { User } from '~core/models/user.model';

@Component({
  selector: 'idl-organisation-users',
  templateUrl: './organisation-users.component.html',
  styleUrls: ['./organisation-users.component.scss']
})
export class OrganisationUsersComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  displayedColumns: string[] = [
    'email',
    'firstName',
    'lastLoginDate',
    'comments',
    'crmLink',
    'lockedOut'
  ];

  dataSource = new MatTableDataSource<User>();

  isLoading = true;

  @Input() organisationId: number;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private _usersService: UsersService) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this._usersService
      .list(null, null, this.organisationId, true, false)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: User[]) => {
        this.isLoading = false;
        this.dataSource.data = data;

        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        });
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  applyFilter(event: KeyboardEvent) {
    this.dataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
  }
}
